/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminAssistantBreakdownResponse } from '../models';
// @ts-ignore
import type { AdminAssistantConversationResponse } from '../models';
// @ts-ignore
import type { AdminAssistantConversationsResponse } from '../models';
// @ts-ignore
import type { AdminAssistantOverviewResponse } from '../models';
// @ts-ignore
import type { AdminAssistantTimeseriesResponse } from '../models';
// @ts-ignore
import type { AdminAssistantUsersResponse } from '../models';
// @ts-ignore
import type { AssistantMessage } from '../models';
// @ts-ignore
import type { AssistantUsage } from '../models';
// @ts-ignore
import type { DecideAssistantActionBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllAssistantConversationsResponse } from '../models';
// @ts-ignore
import type { GetAssistantConversationResponse } from '../models';
// @ts-ignore
import type { SendAssistantMessageBody } from '../models';
// @ts-ignore
import type { SendAssistantMessageResponse } from '../models';
// @ts-ignore
import type { StartCheckoutRescueBody } from '../models';
// @ts-ignore
import type { StartCheckoutRescueResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
/**
 * AssistantApiApi - axios parameter creator
 */
export const AssistantApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} actionId 
         * @param {string} messageId 
         * @param {DecideAssistantActionBody} decideAssistantActionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiDecideAssistantAction: async (actionId: string, messageId: string, decideAssistantActionBody: DecideAssistantActionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('assistantApiDecideAssistantAction', 'actionId', actionId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('assistantApiDecideAssistantAction', 'messageId', messageId)
            // verify required parameter 'decideAssistantActionBody' is not null or undefined
            assertParamExists('assistantApiDecideAssistantAction', 'decideAssistantActionBody', decideAssistantActionBody)
            const localVarPath = `/assistant/messages/{message_id}/actions/{action_id}`
                .replace('{action_id}', encodeURIComponent(String(actionId)))
                .replace('{message_id}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(decideAssistantActionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiDeleteAssistantConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('assistantApiDeleteAssistantConversation', 'conversationId', conversationId)
            const localVarPath = `/assistant/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantBreakdown: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/assistant/statistics/breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('assistantApiGetAdminAssistantConversation', 'conversationId', conversationId)
            const localVarPath = `/admin/assistant/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {AssistantApiGetAdminAssistantConversationsKindEnum} [kind] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AssistantApiGetAdminAssistantConversationsSortByEnum} [sortBy] 
         * @param {AssistantApiGetAdminAssistantConversationsSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {boolean} [withProblems] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantConversations: async (endDate?: string | null, excludeInternal?: boolean, kind?: AssistantApiGetAdminAssistantConversationsKindEnum, page?: number, pageSize?: number, search?: string | null, sortBy?: AssistantApiGetAdminAssistantConversationsSortByEnum, sortOrder?: AssistantApiGetAdminAssistantConversationsSortOrderEnum, startDate?: string | null, userId?: string | null, withProblems?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (withProblems !== undefined) {
                localVarQueryParameter['with_problems'] = withProblems;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ask Abekus AI headline numbers for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantOverview: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/assistant/statistics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {AssistantApiGetAdminAssistantTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantTimeseries: async (endDate?: string | null, excludeInternal?: boolean, granularity?: AssistantApiGetAdminAssistantTimeseriesGranularityEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/assistant/statistics/timeseries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssistantApiGetAdminAssistantUsersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AssistantApiGetAdminAssistantUsersSortByEnum} [sortBy] 
         * @param {AssistantApiGetAdminAssistantUsersSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantUsers: async (activity?: AssistantApiGetAdminAssistantUsersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: AssistantApiGetAdminAssistantUsersSortByEnum, sortOrder?: AssistantApiGetAdminAssistantUsersSortOrderEnum, startDate?: string | null, userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/assistant/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAssistantConversation: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('assistantApiGetAssistantConversation', 'conversationId', conversationId)
            const localVarPath = `/assistant/conversations/{conversation_id}`
                .replace('{conversation_id}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAssistantMessage: async (messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('assistantApiGetAssistantMessage', 'messageId', messageId)
            const localVarPath = `/assistant/messages/{message_id}`
                .replace('{message_id}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAssistantUsage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assistant/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiListAssistantConversations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assistant/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendAssistantMessageBody} sendAssistantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiSendAssistantMessage: async (sendAssistantMessageBody: SendAssistantMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendAssistantMessageBody' is not null or undefined
            assertParamExists('assistantApiSendAssistantMessage', 'sendAssistantMessageBody', sendAssistantMessageBody)
            const localVarPath = `/assistant/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAssistantMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCheckoutRescueBody} startCheckoutRescueBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiStartCheckoutRescue: async (startCheckoutRescueBody: StartCheckoutRescueBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startCheckoutRescueBody' is not null or undefined
            assertParamExists('assistantApiStartCheckoutRescue', 'startCheckoutRescueBody', startCheckoutRescueBody)
            const localVarPath = `/assistant/checkout-rescue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCheckoutRescueBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssistantApiApi - functional programming interface
 */
export const AssistantApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssistantApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} actionId 
         * @param {string} messageId 
         * @param {DecideAssistantActionBody} decideAssistantActionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiDecideAssistantAction(actionId: string, messageId: string, decideAssistantActionBody: DecideAssistantActionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiDecideAssistantAction(actionId, messageId, decideAssistantActionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiDecideAssistantAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiDeleteAssistantConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiDeleteAssistantConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiDeleteAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAdminAssistantBreakdown(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssistantBreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAdminAssistantBreakdown(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAdminAssistantBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAdminAssistantConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssistantConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAdminAssistantConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAdminAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {AssistantApiGetAdminAssistantConversationsKindEnum} [kind] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AssistantApiGetAdminAssistantConversationsSortByEnum} [sortBy] 
         * @param {AssistantApiGetAdminAssistantConversationsSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {boolean} [withProblems] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAdminAssistantConversations(endDate?: string | null, excludeInternal?: boolean, kind?: AssistantApiGetAdminAssistantConversationsKindEnum, page?: number, pageSize?: number, search?: string | null, sortBy?: AssistantApiGetAdminAssistantConversationsSortByEnum, sortOrder?: AssistantApiGetAdminAssistantConversationsSortOrderEnum, startDate?: string | null, userId?: string | null, withProblems?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssistantConversationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAdminAssistantConversations(endDate, excludeInternal, kind, page, pageSize, search, sortBy, sortOrder, startDate, userId, withProblems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAdminAssistantConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ask Abekus AI headline numbers for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAdminAssistantOverview(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssistantOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAdminAssistantOverview(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAdminAssistantOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {AssistantApiGetAdminAssistantTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAdminAssistantTimeseries(endDate?: string | null, excludeInternal?: boolean, granularity?: AssistantApiGetAdminAssistantTimeseriesGranularityEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssistantTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAdminAssistantTimeseries(endDate, excludeInternal, granularity, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAdminAssistantTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AssistantApiGetAdminAssistantUsersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AssistantApiGetAdminAssistantUsersSortByEnum} [sortBy] 
         * @param {AssistantApiGetAdminAssistantUsersSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAdminAssistantUsers(activity?: AssistantApiGetAdminAssistantUsersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: AssistantApiGetAdminAssistantUsersSortByEnum, sortOrder?: AssistantApiGetAdminAssistantUsersSortOrderEnum, startDate?: string | null, userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssistantUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAdminAssistantUsers(activity, endDate, excludeInternal, page, pageSize, search, sortBy, sortOrder, startDate, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAdminAssistantUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAssistantConversation(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssistantConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAssistantConversation(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAssistantConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAssistantMessage(messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAssistantMessage(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAssistantMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiGetAssistantUsage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssistantUsage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiGetAssistantUsage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiGetAssistantUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiListAssistantConversations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllAssistantConversationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiListAssistantConversations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiListAssistantConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendAssistantMessageBody} sendAssistantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiSendAssistantMessage(sendAssistantMessageBody: SendAssistantMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendAssistantMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiSendAssistantMessage(sendAssistantMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiSendAssistantMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StartCheckoutRescueBody} startCheckoutRescueBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assistantApiStartCheckoutRescue(startCheckoutRescueBody: StartCheckoutRescueBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCheckoutRescueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assistantApiStartCheckoutRescue(startCheckoutRescueBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApiApi.assistantApiStartCheckoutRescue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssistantApiApi - factory interface
 */
export const AssistantApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssistantApiApiFp(configuration)
    return {
        /**
         * 
         * @param {AssistantApiApiAssistantApiDecideAssistantActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiDecideAssistantAction(requestParameters: AssistantApiApiAssistantApiDecideAssistantActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantMessage> {
            return localVarFp.assistantApiDecideAssistantAction(requestParameters.actionId, requestParameters.messageId, requestParameters.decideAssistantActionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiDeleteAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiDeleteAssistantConversation(requestParameters: AssistantApiApiAssistantApiDeleteAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.assistantApiDeleteAssistantConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAdminAssistantBreakdownRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantBreakdown(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantBreakdownRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssistantBreakdownResponse> {
            return localVarFp.assistantApiGetAdminAssistantBreakdown(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAdminAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantConversation(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssistantConversationResponse> {
            return localVarFp.assistantApiGetAdminAssistantConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAdminAssistantConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantConversations(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantConversationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssistantConversationsResponse> {
            return localVarFp.assistantApiGetAdminAssistantConversations(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.kind, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, requestParameters.withProblems, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ask Abekus AI headline numbers for a window, against the window before it.
         * @param {AssistantApiApiAssistantApiGetAdminAssistantOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantOverview(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssistantOverviewResponse> {
            return localVarFp.assistantApiGetAdminAssistantOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAdminAssistantTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantTimeseries(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantTimeseriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssistantTimeseriesResponse> {
            return localVarFp.assistantApiGetAdminAssistantTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAdminAssistantUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAdminAssistantUsers(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssistantUsersResponse> {
            return localVarFp.assistantApiGetAdminAssistantUsers(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAssistantConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAssistantConversation(requestParameters: AssistantApiApiAssistantApiGetAssistantConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAssistantConversationResponse> {
            return localVarFp.assistantApiGetAssistantConversation(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiGetAssistantMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAssistantMessage(requestParameters: AssistantApiApiAssistantApiGetAssistantMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssistantMessage> {
            return localVarFp.assistantApiGetAssistantMessage(requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiGetAssistantUsage(options?: RawAxiosRequestConfig): AxiosPromise<AssistantUsage> {
            return localVarFp.assistantApiGetAssistantUsage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiListAssistantConversations(options?: RawAxiosRequestConfig): AxiosPromise<GetAllAssistantConversationsResponse> {
            return localVarFp.assistantApiListAssistantConversations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiSendAssistantMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiSendAssistantMessage(requestParameters: AssistantApiApiAssistantApiSendAssistantMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendAssistantMessageResponse> {
            return localVarFp.assistantApiSendAssistantMessage(requestParameters.sendAssistantMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssistantApiApiAssistantApiStartCheckoutRescueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assistantApiStartCheckoutRescue(requestParameters: AssistantApiApiAssistantApiStartCheckoutRescueRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartCheckoutRescueResponse> {
            return localVarFp.assistantApiStartCheckoutRescue(requestParameters.startCheckoutRescueBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assistantApiDecideAssistantAction operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiDecideAssistantActionRequest {
    readonly actionId: string

    readonly messageId: string

    readonly decideAssistantActionBody: DecideAssistantActionBody
}

/**
 * Request parameters for assistantApiDeleteAssistantConversation operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiDeleteAssistantConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for assistantApiGetAdminAssistantBreakdown operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAdminAssistantBreakdownRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for assistantApiGetAdminAssistantConversation operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAdminAssistantConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for assistantApiGetAdminAssistantConversations operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAdminAssistantConversationsRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly kind?: AssistantApiGetAdminAssistantConversationsKindEnum

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: AssistantApiGetAdminAssistantConversationsSortByEnum

    readonly sortOrder?: AssistantApiGetAdminAssistantConversationsSortOrderEnum

    readonly startDate?: string | null

    readonly userId?: string | null

    readonly withProblems?: boolean
}

/**
 * Request parameters for assistantApiGetAdminAssistantOverview operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAdminAssistantOverviewRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for assistantApiGetAdminAssistantTimeseries operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAdminAssistantTimeseriesRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly granularity?: AssistantApiGetAdminAssistantTimeseriesGranularityEnum

    readonly startDate?: string | null
}

/**
 * Request parameters for assistantApiGetAdminAssistantUsers operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAdminAssistantUsersRequest {
    readonly activity?: AssistantApiGetAdminAssistantUsersActivityEnum

    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: AssistantApiGetAdminAssistantUsersSortByEnum

    readonly sortOrder?: AssistantApiGetAdminAssistantUsersSortOrderEnum

    readonly startDate?: string | null

    readonly userId?: string | null
}

/**
 * Request parameters for assistantApiGetAssistantConversation operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAssistantConversationRequest {
    readonly conversationId: string
}

/**
 * Request parameters for assistantApiGetAssistantMessage operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiGetAssistantMessageRequest {
    readonly messageId: string
}

/**
 * Request parameters for assistantApiSendAssistantMessage operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiSendAssistantMessageRequest {
    readonly sendAssistantMessageBody: SendAssistantMessageBody
}

/**
 * Request parameters for assistantApiStartCheckoutRescue operation in AssistantApiApi.
 */
export interface AssistantApiApiAssistantApiStartCheckoutRescueRequest {
    readonly startCheckoutRescueBody: StartCheckoutRescueBody
}

/**
 * AssistantApiApi - object-oriented interface
 */
export class AssistantApiApi extends BaseAPI {
    /**
     * 
     * @param {AssistantApiApiAssistantApiDecideAssistantActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiDecideAssistantAction(requestParameters: AssistantApiApiAssistantApiDecideAssistantActionRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiDecideAssistantAction(requestParameters.actionId, requestParameters.messageId, requestParameters.decideAssistantActionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiDeleteAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiDeleteAssistantConversation(requestParameters: AssistantApiApiAssistantApiDeleteAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiDeleteAssistantConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAdminAssistantBreakdownRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAdminAssistantBreakdown(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantBreakdownRequest = {}, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAdminAssistantBreakdown(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAdminAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAdminAssistantConversation(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAdminAssistantConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAdminAssistantConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAdminAssistantConversations(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantConversationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAdminAssistantConversations(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.kind, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, requestParameters.withProblems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ask Abekus AI headline numbers for a window, against the window before it.
     * @param {AssistantApiApiAssistantApiGetAdminAssistantOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAdminAssistantOverview(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAdminAssistantOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAdminAssistantTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAdminAssistantTimeseries(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantTimeseriesRequest = {}, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAdminAssistantTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAdminAssistantUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAdminAssistantUsers(requestParameters: AssistantApiApiAssistantApiGetAdminAssistantUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAdminAssistantUsers(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAssistantConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAssistantConversation(requestParameters: AssistantApiApiAssistantApiGetAssistantConversationRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAssistantConversation(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiGetAssistantMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAssistantMessage(requestParameters: AssistantApiApiAssistantApiGetAssistantMessageRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAssistantMessage(requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiGetAssistantUsage(options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiGetAssistantUsage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiListAssistantConversations(options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiListAssistantConversations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiSendAssistantMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiSendAssistantMessage(requestParameters: AssistantApiApiAssistantApiSendAssistantMessageRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiSendAssistantMessage(requestParameters.sendAssistantMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssistantApiApiAssistantApiStartCheckoutRescueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assistantApiStartCheckoutRescue(requestParameters: AssistantApiApiAssistantApiStartCheckoutRescueRequest, options?: RawAxiosRequestConfig) {
        return AssistantApiApiFp(this.configuration).assistantApiStartCheckoutRescue(requestParameters.startCheckoutRescueBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const AssistantApiGetAdminAssistantConversationsKindEnum = {
    Chat: 'chat',
    Rescue: 'rescue',
} as const;
export type AssistantApiGetAdminAssistantConversationsKindEnum = typeof AssistantApiGetAdminAssistantConversationsKindEnum[keyof typeof AssistantApiGetAdminAssistantConversationsKindEnum];
export const AssistantApiGetAdminAssistantConversationsSortByEnum = {
    LastMessageAt: 'last_message_at',
    CreatedAt: 'created_at',
    Questions: 'questions',
    Problems: 'problems',
    ToolCalls: 'tool_calls',
    CostUsd: 'cost_usd',
} as const;
export type AssistantApiGetAdminAssistantConversationsSortByEnum = typeof AssistantApiGetAdminAssistantConversationsSortByEnum[keyof typeof AssistantApiGetAdminAssistantConversationsSortByEnum];
export const AssistantApiGetAdminAssistantConversationsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type AssistantApiGetAdminAssistantConversationsSortOrderEnum = typeof AssistantApiGetAdminAssistantConversationsSortOrderEnum[keyof typeof AssistantApiGetAdminAssistantConversationsSortOrderEnum];
export const AssistantApiGetAdminAssistantTimeseriesGranularityEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
} as const;
export type AssistantApiGetAdminAssistantTimeseriesGranularityEnum = typeof AssistantApiGetAdminAssistantTimeseriesGranularityEnum[keyof typeof AssistantApiGetAdminAssistantTimeseriesGranularityEnum];
export const AssistantApiGetAdminAssistantUsersActivityEnum = {
    All: 'all',
    Active: 'active',
    Inactive: 'inactive',
    New: 'new',
    LimitHit: 'limit_hit',
} as const;
export type AssistantApiGetAdminAssistantUsersActivityEnum = typeof AssistantApiGetAdminAssistantUsersActivityEnum[keyof typeof AssistantApiGetAdminAssistantUsersActivityEnum];
export const AssistantApiGetAdminAssistantUsersSortByEnum = {
    LastQuestionAt: 'last_question_at',
    FirstQuestionAt: 'first_question_at',
    Name: 'name',
    LifetimeQuestions: 'lifetime_questions',
    LifetimeChats: 'lifetime_chats',
    Questions: 'questions',
    Chats: 'chats',
    ActiveDays: 'active_days',
    Problems: 'problems',
    ToolCalls: 'tool_calls',
    ActionsConfirmed: 'actions_confirmed',
    CostUsd: 'cost_usd',
} as const;
export type AssistantApiGetAdminAssistantUsersSortByEnum = typeof AssistantApiGetAdminAssistantUsersSortByEnum[keyof typeof AssistantApiGetAdminAssistantUsersSortByEnum];
export const AssistantApiGetAdminAssistantUsersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type AssistantApiGetAdminAssistantUsersSortOrderEnum = typeof AssistantApiGetAdminAssistantUsersSortOrderEnum[keyof typeof AssistantApiGetAdminAssistantUsersSortOrderEnum];
